import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceService } from 'src/app/services/devices/device.service';
import { LumSchedulerPeriodsComponent } from './lum-scheduler-periods/lum-scheduler-periods.component';
import { LumSchedulerProgramsComponent } from './lum-scheduler-programs/lum-scheduler-programs.component';

export type LumSchedulerViewMode = 'programs' | 'periods';

@Component({
  selector: 'app-lum-scheduler',
  imports: [
    CommonModule,
    TranslateModule,
    LumSchedulerProgramsComponent,
    LumSchedulerPeriodsComponent,
  ],
  templateUrl: './lum-scheduler.component.html',
  styleUrl: './lum-scheduler.component.scss',
})
export class LumSchedulerComponent implements OnInit {

  @Input() allSettings = false;

  device = '';
  loading = false;
  viewMode: LumSchedulerViewMode = 'programs';
  schedulerData: unknown = null;
  astcalData: unknown = null;

  constructor(
    private _aRoute: ActivatedRoute,
    private _device: DeviceService,
  ) {}

  ngOnInit(): void {
    this._aRoute.parent?.parent?.params.subscribe((params: Params) => {
      this.device = params['serial'];
      this.loadSchedulerData();
    });
  }

  onSchedulesChanged(): void {
    this.reloadSchedulerData(false);
  }

  onPeriodsChanged(): void {
    this.reloadSchedulerData(false);
  }

  private loadSchedulerData(): void {
    if (!this.device) return;

    this.loading = true;
    this.schedulerData = null;

    this._device.getModuleInfo(this.device, 'astcal').subscribe({
      next: (data) => {
        this.astcalData = data;
      },
      error: () => {
        this.astcalData = null;
      },
    });

    this.reloadSchedulerData(false);
  }

  /** Recarga solo el módulo scheduler; por defecto sin spinner ni vaciado de tabla. */
  private reloadSchedulerData(showLoading = true): void {
    if (!this.device) return;

    if (showLoading) {
      this.loading = true;
      this.schedulerData = null;
    }

    this._device.getModuleInfo(this.device, 'scheduler').subscribe({
      next: (data) => {
        this.schedulerData = data;
        this.loading = false;
      },
      error: () => {
        if (showLoading) {
          this.schedulerData = null;
        }
        this.loading = false;
      },
    });
  }
}
